import * as actionTypes from "../../constants/actionTypes";
import { OFFER_TYPES } from "../../constants/offerTypes";
import { getPropositions } from "../../api/proposition";

const invalidateSimOnlyOffers = () => {
  return {
    type: actionTypes.INVALIDATE_SIM_ONLY_OFFERS_DATA
  };
};

const loadSimOnlyOffers = (
  clientConfig,
  dataStatus,
  filter,
  sort,
  withDetails = false
) => {
  return {
    type: actionTypes.LOAD_SIM_ONLY_OFFERS_DATA,
    promise: getPropositions(
      clientConfig,
      dataStatus,
      filter,
      sort,
      OFFER_TYPES.simOnly,
      withDetails
    )
  };
};

export { invalidateSimOnlyOffers, loadSimOnlyOffers };
